<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">Movimientos de Saldo</div>
            </div>
          </div>

          <!-- <div class="info">
            <span>
              <em class="fa fa-exclamation-triangle colorInfo"></em>
              Los movimientos menores a $500 MXN se verán reflejados al momento;
              los movimientos iguales o mayores a $500 MXN requieren
              autorización del área de Contabilidad por lo que los cambios no se
              verán reflejados inmediatamente. Se enviará un correo
              notificandoles del movimiento para su autorización.
            </span>
          </div> -->
          <div
            class="flxDivs"
            v-if="$localStorageService.can('BO_22_consulta_mov_sald')"
          >
            <div class="div20">
              <b-tabs>
                <b-tab active title="Movimientos de saldo">
                  <b-form-group label="Clínica" class="mginTop10">
                    <v-select
                      class="mginTop10"
                      :clearable="false"
                      :options="listaClinicas"
                      v-model="datosBusqueda.cliId"
                      :reduce="(variable) => variable.idClinica"
                      label="nombreClinica"
                      placeholder="Selecciona una clínica"
                    >
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Área" class="mginTop10">
                    <v-select
                      class="mginTop10"
                      :clearable="false"
                      :options="listaAreas"
                      v-model="datosBusqueda.idArea"
                      :reduce="(variable) => variable.idArea"
                      label="nombreArea"
                      placeholder="Selecciona una área"
                    >
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Solicitante" class="mginTop10">
                    <span class="inputIconDiv">
                      <!-- <v-select
                        style="width: 100%"
                        label="nombre"
                        :filterable="false"
                        :options="colaboradores"
                        @search="getColaboradores"
                        :reduce="(colaborador) => colaborador.id"
                        v-model="datosBusqueda.solicitanteId"
                        placeholder=""
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select> -->

                      <p
                        style="width: 100%; text-align: left; font-weight: bold"
                      >
                        {{ nombreUsuario }}
                      </p>

                      <b-button
                        variant="primary"
                        disabled
                        v-if="loadingColaboradores"
                      >
                        <b-spinner small></b-spinner>
                      </b-button>
                    </span>
                  </b-form-group>

                  <b-form-group label="Nombre de Paciente" class="mginTop10">
                    <span class="inputIconDiv">
                      <v-select
                        style="width: 100%"
                        label="nombre"
                        :filterable="false"
                        :options="patients"
                        @search="getPatients"
                        :reduce="(patient) => patient.id"
                        v-model="datosBusqueda.pacienteId"
                        placeholder=""
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select>
                      <b-button
                        variant="primary"
                        disabled
                        v-if="loadingPatient"
                      >
                        <b-spinner small></b-spinner>
                      </b-button>
                    </span>
                  </b-form-group>

                  <b-form-group
                    label="Saldo Actual del Paciente"
                    class="mginTop10"
                  >
                    <b-form-input
                      v-model="datosBusqueda.saldo"
                      disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Cantidad" class="mginTop10">
                    <b-form-input
                      v-model="datosBusqueda.cantidad"
                      type="number"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Razon del Movimiento" class="mginTop10">
                    <b-form-textarea
                      v-model="datosBusqueda.razon"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>

                  <b-form-group
                    label="Documentos:"
                    label-align="left"
                    class="mginInputTrt"
                    id="fieldset-4"
                  >
                    <b-form-file
                      class="mt-3"
                      plain
                      @change="selectFile"
                      multiple
                    ></b-form-file>
                  </b-form-group>

                  <b-button
                    v-if="$localStorageService.can('BO_22_guardar')"
                    variant="outline-primary"
                    :disabled="
                      datosBusqueda.cliId == null ||
                      datosBusqueda.pacienteId == null ||
                      datosBusqueda.razon == null ||
                      datosBusqueda.idArea == null ||
                      datosBusqueda.cantidad == null ||
                      btnSave == true
                    "
                    @click="guardarDatos"
                    ><span v-if="loadingGuardar == false"> Guardar </span>
                    <b-spinner small v-else></b-spinner>
                  </b-button>
                </b-tab>

                <b-tab title="Traspasos">
                  <b-form-group label="Clínica" class="mginTop10">
                    <v-select
                      class="mginTop10"
                      :clearable="false"
                      :options="listaClinicas"
                      v-model="traspaso.cliId"
                      :reduce="(variable) => variable.idClinica"
                      label="nombreClinica"
                      placeholder="Selecciona una clínica"
                    >
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Área" class="mginTop10">
                    <v-select
                      class="mginTop10"
                      :clearable="false"
                      :options="listaAreas"
                      v-model="traspaso.idArea"
                      :reduce="(variable) => variable.idArea"
                      label="nombreArea"
                      placeholder="Selecciona una área"
                    >
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Solicitante" class="mginTop10">
                    <span class="inputIconDiv">
                      <p
                        style="width: 100%; text-align: left; font-weight: bold"
                      >
                        {{ nombreUsuario }}
                      </p>

                      <b-button
                        variant="primary"
                        disabled
                        v-if="loadingColaboradores"
                      >
                        <b-spinner small></b-spinner>
                      </b-button>
                    </span>
                  </b-form-group>

                  <b-form-group label="Traspaso del Paciente" class="mginTop10">
                    <span class="inputIconDiv">
                      <v-select
                        style="width: 100%"
                        label="nombre"
                        :filterable="false"
                        :options="patientsTraspaso"
                        @search="getPatientsTraspaso"
                        :reduce="(patient) => patient.id"
                        v-model="traspaso.pacienteIdB"
                        placeholder=""
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select>
                      <b-button
                        variant="primary"
                        disabled
                        v-if="loadingPatientTraspaso"
                      >
                        <b-spinner small></b-spinner>
                      </b-button>
                    </span>
                  </b-form-group>

                  <b-form-group
                    label="Saldo Actual del Paciente"
                    class="mginTop10"
                  >
                    <b-form-input
                      v-model="traspaso.saldo"
                      disabled
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Cantidad" class="mginTop10">
                    <b-form-input
                      v-model="traspaso.cantidad"
                      type="number"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group label="Al Paciente" class="mginTop10">
                    <span class="inputIconDiv">
                      <v-select
                        :disabled="traspaso.saldo < 1"
                        style="width: 100%"
                        label="nombre"
                        :filterable="false"
                        :options="patientsReceptor"
                        @search="getPatientsReceptor"
                        :reduce="(patient) => patient.id"
                        v-model="traspaso.pacienteIdA"
                        placeholder=""
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select>
                      <b-button
                        variant="primary"
                        disabled
                        v-if="loadingPatientReceptor"
                      >
                        <b-spinner small></b-spinner>
                      </b-button>
                    </span>
                  </b-form-group>

                  <b-form-group label="Razon del Movimiento" class="mginTop10">
                    <b-form-textarea
                      v-model="traspaso.razon"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>

                  <b-form-group
                    label="Documentos:"
                    label-align="left"
                    class="mginInputTrt"
                    id="fieldset-4"
                  >
                    <b-form-file
                      class="mt-3"
                      plain
                      @change="selectFile"
                      multiple
                    ></b-form-file>
                  </b-form-group>

                  <b-button
                    v-if="$localStorageService.can('BO_22_guardar')"
                    variant="outline-primary"
                    :disabled="
                      traspaso.cliId == null ||
                      traspaso.pacienteIdA == null ||
                      traspaso.razon == null ||
                      traspaso.idArea == null ||
                      traspaso.cantidad == null ||
                      traspaso.pacienteIdB == null ||
                      btnSaveTraspaso == true
                    "
                    @click="guardarDatosTraspaso"
                    ><span v-if="loadingGuardar == false"> Guardar </span>
                    <b-spinner small v-else></b-spinner>
                  </b-button>
                </b-tab>
              </b-tabs>
            </div>
            <div class="div80">
              <span class="title_hist">Historial de Recibos</span>
              <br />
              <strong
                >Escribe el nombre del paciente en el campo correspondiente de
                la izquiera, selecciona de la lista y se desplegará su historial
                de recibos aquí.</strong
              >
              <b-skeleton-table
                :rows="5"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="infoPaciente != null">
                <b-table
                  responsive
                  striped
                  hover
                  :items="infoPaciente.recibos"
                  v-if="
                    infoPaciente.recibos.length != 0 && cargandoTabla == false
                  "
                ></b-table>
                <br />
                <br />
                <strong
                  v-if="
                    infoPaciente.recibos.length == 0 && cargandoTabla == false
                  "
                  >Sin recibos</strong
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//components
import _ from "lodash";
import Header from "../../components/Header.vue";
import miniToastr from "mini-toastr"; //ES6

export default {
  name: "movimientosSaldo",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      file: [],
      btnSave: false,
      btnSaveTraspaso: false,
      listaClinicas: [],
      nombreUsuario: this.$localStorageService.getNombreCompletoUsuario(),
      datosBusqueda: {
        cliId: this.$localStorageService.getIdClinica(),
        idArea: null,
        solicitanteId: this.$localStorageService.getIdEmpleado(),
        pacienteId: null,
        saldo: null,
        cantidad: null,
        razon: null,
      },
      traspaso: {
        cliId: this.$localStorageService.getIdClinica(),
        idArea: null,
        solicitanteId: this.$localStorageService.getIdEmpleado(),
        pacienteIdA: null,
        pacienteIdB: null,
        saldo: null,
        cantidad: null,
        razon: null,
      },
      loadingPatient: false,
      loadingPatientTraspaso: false,
      loadingPatientReceptor: false,
      loadingColaboradores: false,
      patients: [],
      patientsTraspaso: [],
      patientsReceptor: [],
      colaboradores: [],
      infoPaciente: null,
      infoPacienteA: null,
      cargandoTabla: false,
      loadingGuardar: false,
      listaAreas: [],
      clinicaActual: null,
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.clinicaActual = this.$localStorageService.getIdClinica();

    if (this.clinicaActual == 1) {
      this.llenarClinicas();
      this.llenarAreas([
        "ATENCION Y EXPERIENCIA",
        "DENTAL",
        "FINANZAS Y SOPORTE CORPORATIVO",
        "MERCADOTECNIA, VENTAS CLINICAS & SERVICIO AL PACIENTE",
      ]);
    } else {
      this.listaClinicas = this.$localStorageService.getClinicas();
      this.llenarAreas(["ATENCION Y EXPERIENCIA"]);
    }
  },
  methods: {
    selectFile(e) {
      this.file = [];

      let files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        files.forEach((file) => {
          var doc = new Blob([file], { type: file.type });
          this.file.push(doc);
        });
      }
    },
    llenarClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((response) => {
          if (response.status === 200) {
            this.listaClinicas = response.data.data
              .map((it) => {
                return {
                  idClinica: it.idClinica,
                  nombreClinica: it.strNombre,
                };
              })
              .filter(
                (v, i, a) =>
                  a.findIndex((t) => t.idClinica === v.idClinica) === i
              );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    llenarAreas(arrayAreas) {
      this.$http
        .get(this.$api + "catalogos/listaAreas")
        .then((response) => {
          if (response.status === 200) {
            this.listaAreas = response.data.data;

            this.listaAreas = this.listaAreas.filter((item) =>
              arrayAreas.some(function (itmDos) {
                return itmDos === item.nombreArea;
              })
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPatients(searchTerm) {
      if (searchTerm === "") {
        this.loadingPatient = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingPatient = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api +
              "paciente/perfiles/obtenerDatosPaciente?nombrePaciente=" +
              inputTxt +
              "&busquedaAvanzada=false",
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.patients = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingPatient = false));
      }
    },
    getPatientsTraspaso(searchTerm) {
      if (searchTerm === "") {
        this.loadingPatientTraspaso = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingPatientTraspaso = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api +
              "paciente/perfiles/obtenerDatosPaciente?nombrePaciente=" +
              inputTxt +
              "&busquedaAvanzada=false",
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.patientsTraspaso = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingPatientTraspaso = false));
      }
    },
    getPatientsReceptor(searchTerm) {
      if (searchTerm === "") {
        this.loadingPatientReceptor = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingPatientReceptor = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api +
              "paciente/perfiles/obtenerDatosPaciente?nombrePaciente=" +
              inputTxt +
              "&busquedaAvanzada=false",
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.patientsReceptor = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingPatientReceptor = false));
      }
    },
    getColaboradores(searchTerm) {
      if (searchTerm === "") {
        this.loadingColaboradores = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.loadingColaboradores = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api + "saldo/obtenerDatosEmpleado?nombreEmpleado=" + inputTxt,
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.colaboradores = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingColaboradores = false));
      }
    },
    getDetallePaciente(id, tipo) {
      this.cargandoTabla = true;
      this.$http
        .get(this.$api + "saldo/obtenerDetallePaciente", {
          params: {
            idPaciente: id,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.infoPaciente = response.data.data[0];
            this.datosBusqueda.saldo = this.infoPaciente.saldo;
            this.traspaso.saldo = this.infoPaciente.saldo;

            if (tipo == "traspaso" && this.traspaso.saldo < 1) {
              miniToastr.error(
                "El paciente no tiene saldo a favor para generar traspaso de saldo"
              );
            }

            this.infoPaciente.recibos = _.orderBy(
              this.infoPaciente.recibos,
              ["idRecibo"],
              ["desc"]
            );

            this.infoPaciente.recibos = this.infoPaciente.recibos.map((it) => {
              return {
                Recibo: it.idRecibo,
                Fecha: this.$moment(it.fechaAlta).utc().format("DD/MM/YYYY"),
                Importe:
                  "$" + it.montoPagar != null ? it.montoPagar : 0 + ".00",
                Total:
                  "$" + it.montoPagado != null ? it.montoPagado : 0 + ".00",
                Saldo: "$" + it.saldo != null ? it.saldo : 0 + ".00",
                Clínica: it.clinicaNombre,
                Estatus: it.estatus,
              };
            });
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setTimeout(() => (this.cargandoTabla = false), 1500));
    },
    getDetallePacienteA(id) {
      this.$http
        .get(this.$api + "saldo/obtenerDetallePaciente", {
          params: {
            idPaciente: id,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.infoPacienteA = response.data.data[0];
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    guardarDatos() {
      let config = {
        header: {
          "Content-Type": "application/octet-stream",
        },
      };

      const formData = new FormData();

      if (this.file.length != 0) {
        this.file.forEach((element) => {
          formData.append("imagenes", element);
        });
      }

      formData.append("idPaciente", this.datosBusqueda.pacienteId);
      formData.append("idArea", this.datosBusqueda.idArea);
      formData.append("descripcion", this.datosBusqueda.razon);
      formData.append("idClinica", this.datosBusqueda.cliId);
      formData.append("idEmpleado", this.datosBusqueda.solicitanteId);
      formData.append("idSuptipoPaciente", this.infoPaciente.idSubTipoPaciente);
      formData.append("idTipoPaciente", this.infoPaciente.idTipoPaciente);
      formData.append("totalSaldo", this.datosBusqueda.cantidad);
      formData.append("idUsuario", this.$localStorageService.getIdUsuario());
      formData.append("idSesion", this.infoPaciente.idSesion == null ? 0 : this.infoPaciente.idSesion);

      this.btnSave = true;
      this.loadingGuardar = true;

      if (this.infoPaciente.idBalance == null) {
        // ? POST
        this.$http
          .post(this.$api + "saldo/registrar", formData, config)
          .then((response) => {
            if (response.status === 200) {
              var message = response.data.message
                ? response.data.message
                : "Se genero correctamente el registro";
              miniToastr.success(message);
              setTimeout(() => location.reload(), 1500);
            }
          })
          .catch((error) => {
            this.loadingGuardar = false;
            this.btnSave = false;
            var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el registro";
            miniToastr.info(message);
          });
      } else {
        // ? UPDATE
        formData.append("idBalance", this.infoPaciente.idBalance);
        // formData.idBalance = this.infoPaciente.idBalance;
        this.$http
          .put(this.$api + "saldo/actualizar", formData, config)
          .then((response) => {
            if (response.status === 200) {
              var message = response.data.message
                ? response.data.message
                : "Se actualizó correctamente el registro";
              miniToastr.success(message);

              setTimeout(() => location.reload(), 1500);
            }
          })
          .catch((error) => {
            this.loadingGuardar = false;
            this.btnSave = false;
            var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el registro";
            miniToastr.error(message);
          })
          .finally(() => (this.loadingGuardar = false));
      }
    },
    guardarDatosTraspaso() {
      let config = {
        header: {
          "Content-Type": "application/octet-stream",
        },
      };

      const formData = new FormData();

      if (this.file.length != 0) {
        this.file.forEach((element) => {
          formData.append("imagenes", element);
        });
      }

      formData.append("idPaciente", this.traspaso.pacienteIdA);
      formData.append("idArea", this.traspaso.idArea);
      formData.append("descripcion", this.traspaso.razon);
      formData.append("idClinica", this.traspaso.cliId);
      formData.append("idEmpleado", this.traspaso.solicitanteId);

      formData.append("idSuptipoPaciente", this.infoPaciente.idSubTipoPaciente);
      formData.append("idTipoPaciente", this.infoPaciente.idTipoPaciente);
      formData.append("totalSaldo", this.traspaso.cantidad);
      formData.append("idUsuario", this.$localStorageService.getIdUsuario());
      formData.append("idSesion", this.infoPaciente.idSesion == null ? 0 : this.infoPaciente.idSesion);
      formData.append("idPacienteB", this.traspaso.pacienteIdB);

      this.btnSaveTraspaso = true;
      this.loadingGuardar = true;

      if (this.infoPacienteA.idBalance == null) {
        // ? POST
        this.$http
          .post(this.$api + "saldo/registrar", formData, config)
          .then((response) => {
            if (response.status === 200) {
              var message = response.data.message
                ? response.data.message
                : "Se genero correctamente el registro";
              miniToastr.success(message);
              setTimeout(() => location.reload(), 1500);
            }
          })
          .catch((error) => {
            this.loadingGuardar = false;
            this.btnSaveTraspaso = false;
            var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el registro";
            miniToastr.info(message);
          });
      } else {
        // ? UPDATE
        // params.idBalance = this.infoPacienteA.idBalance;
        formData.append("idBalance", this.infoPacienteA.idBalance);
        this.$http
          .put(this.$api + "saldo/actualizar", formData, config)
          .then((response) => {
            if (response.status === 200) {
              var message = response.data.message
                ? response.data.message
                : "Se actualizó correctamente el registro";
              miniToastr.success(message);

              setTimeout(() => location.reload(), 1500);
            }
          })
          .catch((error) => {
            this.btnSaveTraspaso = false;
            this.loadingGuardar = false;
            var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear el registro";
            miniToastr.info(message);
          })
          .finally(() => (this.loadingGuardar = false));
      }
    },
  },
  watch: {
    "datosBusqueda.pacienteId": function () {
      if (this.datosBusqueda.pacienteId != null) {
        this.getDetallePaciente(this.datosBusqueda.pacienteId, "movimiento");
      }
    },
    "traspaso.pacienteIdB": function () {
      if (this.traspaso.pacienteIdB != null) {
        this.getDetallePaciente(this.traspaso.pacienteIdB, "traspaso");
      }
    },
    "traspaso.pacienteIdA": function () {
      if (this.traspaso.pacienteIdA != null) {
        this.getDetallePacienteA(this.traspaso.pacienteIdA);
      }
    },
  },
};
</script>
<style scoped>
.mginTop10 {
  text-align: left;
}

.inputIconDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title_hist {
  font-weight: bolder;
  font-size: 25px;
  color: #053672;
}

.colorInfo {
  color: #ffc107;
}

.info {
  margin-top: 10px;
  background-color: #fff87c;
  border: 2px solid #fbb917;
  padding: 10px;
  border-radius: 10px;
}

.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div20 {
  width: 25%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.div80 {
  width: 73%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.txtCard {
  padding-left: 16px !important;
}

.mginInputTrt {
  padding: 10px;
  font-weight: bolder !important;
}
</style>
